<template>
    <div>
        <img :src="$store.state.formSuccess && $store.state.argann != '' ? `https://action.metaffiliation.com/trk.php?mclic=${ pixel }&argann=${ $store.state.argann }&altid=${ $store.state.altid }` : ''" width="1" height="1" border="0"/>
        <img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1466652996976886&ev=Lead&noscript=1"/>
    </div>
</template>

<script>
export default {
    name: 'Pixel',
    data() {
        return {
            pixel: process.env.VUE_APP_MCLIC,
        };
    },
    mounted() {
        this.addRedditPixel();
    },
    methods: {
        addRedditPixel() {
            const scriptTag = document.createElement('script');
            scriptTag.innerHTML = `!function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement("script");t.src="https://www.redditstatic.com/ads/pixel.js",t.async=!0;var s=d.getElementsByTagName("script")[0];s.parentNode.insertBefore(t,s)}}(window,document);rdt('init','t2_a5ed1apr');rdt('track', 'Lead');`;
            document.head.appendChild(scriptTag);
        },
    },
};
</script>

<style>

</style>
